module.exports = __webpack_public_path__ + "img/Nick.08ccac23.jpg";